// frontend/src/api/referrals.ts

import { API_BASE_URL } from '@/config/apiConfig';
import { createApiClient } from './client';

const referralsApiClient = createApiClient({
  baseURL: API_BASE_URL,
});

// Fire-and-forget scan counter for /bar/<ref> smart links. Never throws and
// never blocks navigation - attribution telemetry must not cost a signup.
export const recordReferralScan = (ref: string): void => {
  referralsApiClient
    .post('/referrals/scan', { ref }, { timeout: 4000 })
    .catch(() => {
      /* best-effort */
    });
};
